export const SET_PACKSITES = 'SET_PACKSITES';
export const SET_NO_MORE_PACKSITE = 'SET_NO_MORE_PACKSITE';
export const APPEND_PACKSITES = 'APPEND_PACKSITES';
export const SET_PACKSITE_FILTERS = 'SET_PACKSITE_FILTERS';
export const SET_PACKSITE_STATE = 'SET_PACKSITE_STATE';